// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2XAeb","dragIcon":"Choice_dragIcon__2z0Mn","left":"Choice_left__1LSXm","input":"Choice_input__3ewwM"};